import { FC, useContext } from "react";
import { UserAuthContext } from "../../context/UserContext";
import { DashboardHomeContentCustomer } from "./components/content-customer";
import { DashboardHomeContent } from "./components/content";

export const DashboardHomePane: FC = () => {
  const { appUser } = useContext(UserAuthContext);

  // if (appUser.isClient()) {
  //   return <DashboardHomeContentCustomer />;
  // }

  return <DashboardHomeContent />;
};
